'use strict'

const merge = require('webpack-merge')
const prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  ANALYTICS_ID: '"UA-129739269-1"',
  EXPORT_DATA_URL: '"https://us-central1-pollscape-d2b4b.cloudfunctions.net/exportData"',
  DOMAIN: '"pollscape-d2b4b.firebaseapp.com"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 173
// module chunks = 10